/* globals jQuery */
import 'fitvids.1.1.0'
import './effects.js'
import responsiveNav from './responsive-nav.js'

(($) => {

    const html = document.querySelector('html');
    html.classList.remove('no-js')
    html.classList.add('js');

    // Make nav menu nice & responsive
    const mainNav = document.querySelector('nav.main-nav');
    if( mainNav ){
        responsiveNav(mainNav,{
            navType: 'offCanvas',
            hasSearchInNav: mainNav.dataset.hasSearch === 'true',
            searchDialogSelector: '#searchDialog',
            closeOnOutsideClick: true
        });
    }

    // Responsive Videos
    $('.rtecontent').fitVids();

})(jQuery)
